// src/steps/StepDates.tsx
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import React from 'react';
import { DateRange, RangeKeyDict } from 'react-date-range';
import { es } from 'date-fns/locale';
import { differenceInCalendarDays, addDays, eachDayOfInterval } from 'date-fns';

import styles   from '../styles/stepDates.module.css';
import logosImg from '../assets/web_logos_bandera.svg';
  

interface Props {
  dateRange    : { start: Date; end: Date };
  setDateRange : (dr: { start: Date; end: Date }) => void;
  /** callback que recibe el array de días seleccionados [1,2,3…] */
  onNext       : (days: number[]) => void;
}

const MAX_DAYS = 7;                                    // límite

/* recorta endDate para que no supere el tope */
const clampEnd = (start: Date, end: Date) =>
  differenceInCalendarDays(end, start) > MAX_DAYS
    ? addDays(start, MAX_DAYS)
    : end;

const StepDates: React.FC<Props> = ({ dateRange, setDateRange, onNext }) => {
  const handleChange = (r: RangeKeyDict) => {
    const start = r.selection.startDate!;
    const end   = clampEnd(start, r.selection.endDate!);
    setDateRange({ start, end });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const days = eachDayOfInterval({ start: dateRange.start, end: dateRange.end })
                  .map((d, i) => i + 1);              // Día 1, Día 2…
    onNext(days);
  };

  return (
    <div className={styles.card}>
    <form className={styles.form} onSubmit={handleSubmit}>
      
        <h2 className={styles.sectionTitle}>Selecciona fecha de llegada y salida</h2>

        <div className={styles.dateSection}>
          <DateRange
            ranges={[{ startDate: dateRange.start, endDate: dateRange.end, key: 'selection' }]}
            onChange={handleChange}
            moveRangeOnFirstSelection={false}
            months={1}
            direction="horizontal"
            rangeColors={['#1e4f47', '#173f36']}
            locale={es}
            dateDisplayFormat="dd/MM/yyyy"
          />
        </div>

        <div className={styles.buttons}>
          <button type="submit" className={styles.nextButton}>Continuar</button>
        </div>
      


    </form>

    <div className={styles.footerLogos}>
    <img src={logosImg}  alt="NextGenerationEU"     />
    </div>
  </div>
  );
  
  
};

export default StepDates;
